var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 2h-22c-1.656 0-3 1.344-3 3v22c0 1.656 1.344 3 3 3h22c1.656 0 3-1.344 3-3v-22c0-1.656-1.344-3-3-3zM9.938 24.031c-0.344 0.6-1.113 0.8-1.706 0.456-0.6-0.344-0.8-1.113-0.456-1.706l0.894-1.544c1.006-0.306 1.831-0.069 2.475 0.712zM18.619 20.663h-11.369c-0.688 0-1.25-0.563-1.25-1.25s0.563-1.25 1.25-1.25h3.188l4.087-7.075-1.281-2.212c-0.344-0.6-0.137-1.363 0.456-1.706 0.6-0.344 1.363-0.137 1.706 0.456l0.556 0.962 0.556-0.962c0.344-0.6 1.113-0.8 1.706-0.456 0.6 0.344 0.8 1.113 0.456 1.706l-5.362 9.288h3.881c1.262 0 1.969 1.481 1.419 2.5zM24.75 20.663h-1.813l1.225 2.119c0.344 0.6 0.137 1.363-0.456 1.706-0.6 0.344-1.363 0.137-1.706-0.456-2.056-3.556-3.594-6.231-4.625-8.006-1.044-1.813-0.3-3.625 0.444-4.237 0.819 1.419 2.044 3.544 3.681 6.375h3.25c0.688 0 1.25 0.563 1.25 1.25 0 0.694-0.563 1.25-1.25 1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo44);
export default __webpack_public_path__ + "static/media/logo (44).ad946bf352423931b75ecd03ad8c3ed7.svg";
export { ForwardRef as ReactComponent };